import { createCoreMethod } from '../../utils/createCoreMethod';

export const getCurrentFile = createCoreMethod('getCurrentFile', async () => {
  const currentDate = new Date().getTime();
  const randomValue = Math.round(Math.random() * 100000);

  return {
    // fileKey: figma.fileKey || `file-key-${currentDate}-${randomValue}`,
    // name: figma.root.name || `file-name-${currentDate}-${randomValue}`,
    fileKey: `file-key-${currentDate}-${randomValue}`,
    name: `file-name-${currentDate}-${randomValue}`,
  };
});
